import { GraphQLOrganizationRepository } from "@app/repositories/GraphQLRepositories/OrganizationRepository";
import { GraphQLSupplierRepository } from "@app/repositories/GraphQLRepositories/SupplierRepository";
import { GraphQLUserRepository } from "@app/repositories/GraphQLRepositories/UserRepository";
import { skipToken, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

const OrganizationRepository = new GraphQLOrganizationRepository();
const userRepository = new GraphQLUserRepository();
const supplierRepository = new GraphQLSupplierRepository();
export const useOrg = (uname: string | null) =>
    useQuery({
        queryFn: () => OrganizationRepository.getOrg().then((res) => res.org),
        queryKey: ["org", uname],
        enabled: !!uname,
    });

export const useSupplierUsers = (supplierId?: string) => {
    const { data, ...query } = useQuery({
        queryFn: supplierId
            ? () => userRepository.getUsersFiltered({ supplierId })
            : skipToken,
        queryKey: ["supplierUsers", supplierId],
    });
    return {
        supplierUsers: data?.users,
        ...query,
    };
};

export function useUserFirstSupplier(userId?: string) {
    const { data, ...query } = useQuery({
        queryFn: userId
            ? () => supplierRepository.getUserSupplier()
            : skipToken,
        queryKey: ["supplierFromUser", userId],
    });

    const supplier = useMemo(() => {
        return data?.userSupplier;
    }, [data]);

    return {
        supplier,
        ...query,
    };
}
